import { z } from 'zod'

/** Email settings. */
export const EmailSettings = z.object({
    /** ID of the email settings. */
    id: z.number().positive(),

    email_use_ssl: z.boolean(),

    email_use_tls: z.boolean(),

    /** Domain name to use. */
    email_host: z.string().min(1),

    /** Email port to use. */
    email_port: z.coerce.number().nonnegative().min(1),

    /** Email to use. */
    default_from_email: z.string().email(),

    /** Username to use. */
    email_host_user: z.string().min(1),

    /** User password to use. */
    email_host_password: z.string().min(1),

    /** Signature inside the email. */
    signature: z.string().min(1),

    /** ID of the client. */
    client: z.number().positive(),
})

/** Data email settings to send on create or update. */
export const EmailSettingsPayload = EmailSettings.omit({
    id: true,
    client: true,
})
